import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pickleball-tournament-factsheet',
  templateUrl: './pickleball-tournament-factsheet.component.html',
  styleUrls: ['./pickleball-tournament-factsheet.component.scss']
})
export class PickleballTournamentFactsheetComponent implements OnInit {

  public downloadModal: boolean = true;
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';

  constructor() { }

  ngOnInit(): void {
  }

}
